import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyCs1() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`I.`}
            <br />
            {`Úvodní ustanovení`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Tyto obchodní podmínky (dále jen „obchodní podmínky“) provozovatele webové stránky anandita.cz - Pavola Hudrana, místem podnikání Opava, Kateřinky, Zeyerova 1386/14, IČ: 74869663 (dále jen „poskytovatel“) upravují, v souladu s ustanovením § 1751 odst. 1 zákona č. 89/2012 Sb., občanský zákoník (dále jen „občanský zákoník“), vzájemná práva a povinnosti smluvních stran vzniklé v souvislosti s poskytováním přístupu do placené části webových stránek anandita.cz (dále jen „smlouva“ či „služba“) uzavírané mezi poskytovatelem a třetí osobou (dále jen „uživatel“), která spočívá zejména ve zpřístupňování vybraného obsahu a archivu (dále jen „obsah“) prostřednictvím internetového portálu poskytovatele, který je provozován na webové stránce umístněné na internetové adrese https://app.anandita.cz (včetně všech subdomén a lokalizovaných variant - dále jen „webová stránka“).`}</li>
            <li>{`Právní vztahy poskytovatele a uživatele, které nejsou upraveny těmito obchodními podmínkami ani smlouvou, se řídí občanským zákoníkem a předpisy souvisejícími. `}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={3} className={sList}>
            <li>{`Znění obchodních podmínek může poskytovatel v přiměřeném rozsahu jednostranně měnit či doplňovat, a to zejména v důsledku změny právních předpisů, technických podmínek provozování webové stránky či změny licenčních podmínek ze strany třetích osob využívaných poskytovatelem. Změna obchodních podmínek bude uživateli oznámena elektronickou poštou na jeho e-mailovou adresu uvedenou v uživatelském účtu, byla-li tato poskytnuta, či zobrazením upozornění po přihlášení uživatele do jeho uživatelského rozhraní. Uživatel může změnu obchodních podmínek odmítnout, a to výpovědí smlouvy o poskytování služeb s výpovědní lhůtou 1 měsíc, která začne běžet od prvního dne měsíčního předplatitelského období následujícího po doručení výpovědi a skončí posledním dnem takového období. Výpověď může být provedena i e-mailem z e-mailové adresy uvedené v uživatelském účtu uživatele nebo z příslušného e-mailu poskytovatele`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyCs1;
